/*
 * @Description: 
 * @Author: 宋信峰
 * @Date: 2022-09-06 09:41:47
 * @LastEditTime: 2022-09-08 17:54:39
 * @LastEditors: 宋信峰
 * @Reference: 
 */
import request from './http';

export function reduceIntegral(id, type) {
  const data = {
    storeId: id,
    type: type,
  };
  return request.post('html/store/reduceIntegral', data);
}
export function getStorePhone(id) {
  const data = {
    id: id,
  };
  return request.post('html/user/getStorePhone', data);
}


export function merchants() {
  return request.get('followup/store/merchants')
}
